import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/community/page.tsx");
